import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const LinksContainer = styled.div`
    font-size: ${theme.font.size16};
    color: ${(props) => props.theme.black};
    display: flex;
    flex-direction: column;
    margin: 12px 0 0 0;
    
`;

export const LinkItem = styled.div`
    display: flex;
    align-items: center;
    margin: 24px 0 0 0;
    cursor: pointer;

    & span {
        color: ${(props) => props.theme.greyLink} ;
        margin: 0 0 0 8px;
     }
`;
